// extracted by mini-css-extract-plugin
export var arrows = "_7i-6";
export var decrementer = "_7i-a";
export var disabled = "_7i-4";
export var error = "_7i-1";
export var hiddenText = "_7i-b";
export var incrementer = "_7i-9";
export var input = "_7i-8";
export var inputWrapper = "_7i-0";
export var leadingIcon = "_7i-c";
export var readonly = "_7i-3";
export var regular = "_7i-7";
export var small = "_7i-5";
export var warning = "_7i-2";